import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent } from "util";

export default ConnectComponent(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/napp/index.js